import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';

import { cx } from '../cx';

export interface FieldProps {
  /** id du contrôle, relié au libellé et aux messages. */
  id: string;
  label: string;
  hint?: ReactNode;
  error?: string | null;
  children: ReactNode;
}

/** Libellé, contrôle, aide et erreur, reliés pour les lecteurs d'écran. */
export function Field({ id, label, hint, error, children }: FieldProps) {
  return (
    <div className="ui-field">
      <label className="ui-field__label" htmlFor={id}>
        {label}
      </label>
      {children}
      {hint && !error && (
        <span className="ui-field__hint" id={`${id}-hint`}>
          {hint}
        </span>
      )}
      {error && (
        <span className="ui-field__error" id={`${id}-error`} role="alert">
          {error}
        </span>
      )}
    </div>
  );
}

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ className, invalid, id, ...rest }, ref) {
  return (
    <input
      ref={ref}
      id={id}
      className={cx('ui-input', className)}
      aria-invalid={invalid || undefined}
      {...rest}
      aria-describedby={invalid && id ? `${id}-error` : rest['aria-describedby']}
    />
  );
});
